import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { SettingsPageService } from "@features/settings/services/settings-page.service";
import { ButtonComponent, SubPageComponent } from "@shared/components";
import { formatTimeInput } from "@shared/functions";
import { RequestState, SettingsResponse } from "@shared/models";
import { GlobalService } from "@shared/services";
import { SkeletonModule } from "primeng/skeleton";
import { Observable, tap } from "rxjs";

@Component({
  selector: "app-vmax",
  standalone: true,
  imports: [SubPageComponent, CommonModule, SkeletonModule, ButtonComponent],
  templateUrl: "./vmax.component.html",
  styleUrl: "./vmax.component.scss",
})
export class VmaxComponent implements OnInit {
  globalService = inject(GlobalService);
  settingsPageService = inject(SettingsPageService);

  settings$: Observable<RequestState<SettingsResponse>> = {} as Observable<RequestState<SettingsResponse>>;

  hasChanges: boolean = false;

  originalVmaxValue: string = "";
  newVmaxValue: string = "";

  ngOnInit(): void {
    this.getSettings();
  }

  private getSettings(): void {
    this.settings$ = this.settingsPageService.getSettings().pipe(
      tap((response) => {
        if (response.response) {
          this.originalVmaxValue = response.response.vMaxDefault;
        }
      })
    );
  }

  onKeyDown(keystroke: KeyboardEvent): void {
    const newValue = formatTimeInput(keystroke);
    this.newVmaxValue = newValue;
    this.checkForChanges();
  }

  checkForChanges(): void {
    if (this.originalVmaxValue !== this.newVmaxValue) {
      this.hasChanges = true;
    } else {
      this.hasChanges = false;
    }
  }

  saveSettings(): void {
    this.settingsPageService.saveSettings(this.newVmaxValue, "vmax").subscribe((response) => {
      if (response.response) {
        this.originalVmaxValue = this.newVmaxValue;
        this.checkForChanges();
      }
    });
  }
}
